module.exports = __webpack_public_path__ + "img/logo-light.e0477676.png";